const Note = () => (
    <section id="two">
        <div className="inner">
                <h3>Molimo da naglasite ukoliko postoji dijete s alergijama!</h3>
        </div>
    </section>
);


export default Note;